<template>
  <div class="logged-home">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
    />

    <section class="home-content">
      <div class="text-section">
        <h1>
          Suporte&nbsp;
          <span class="typing-word"></span>
        </h1>

        <p>
          Est&aacute; com dificuldades? Basta entrar em contato
          com nosso suporte, e assim que poss&iacute;vel lhe proveremos a ajuda necess&aacute;ria!
        </p>

        <div class="btn-group">
          <a
            href="https://discord.gg/GV7d8MATYG"
            target="_blank"
            rel="noopener noreferrer"
            class="btn tutorial"
          >Entre em Contato</a>
        </div>

      </div>

      <div class="home-img">
        <DotLottieVue
          class="hero-lottie"
          autoplay
          loop
          src="https://lottie.host/f7bb1e9b-192e-4e8e-8f81-18862cedd8cb/N6CGGREr7p.lottie"
        />
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import Footer from './Footer.vue';

export default {
  name: 'Support',
  components: {
    DotLottieVue,
    Footer,
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body * {
  box-sizing: border-box;
}

.logged-home {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #181a20;
}

.home-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: min(100%, var(--app-max-width));
  margin: 0 auto;
  padding: calc(var(--app-header-h) + 6px) var(--app-gutter) 16px;
  gap: clamp(16px, 3vw, 32px);
  flex: 1;
}

.text-section {
  flex: 1;
  max-width: 560px;
  color: #fff;
}

h1,
h3 {
  font-size: 3rem;
  margin: 0;
}

h1 {
  line-height: 1.1;
  margin-bottom: 18px;
}

.typing-word {
  position: relative;
  display: inline-block;
  color: #4e73df;
  min-width: 175px;
}

.typing-word::before {
  content: 'técnico!';
  color: #4e73df;
  animation: words 20s infinite;
}

.typing-word::after {
  content: '';
  background-color: #181a20;
  position: absolute;
  width: calc(100% + 8px);
  height: 100%;
  border-left: 3px solid #181a20;
  right: -8px;
  animation: cursor 0.6s infinite, typing 20s steps(14) infinite;
}

h3 span {
  position: relative;
  color: #f72585;
}

p {
  font-size: 1.1rem;
  margin: 1rem 0;
  line-height: 1.6;
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif;
}

.btn-group {
  margin: 18px 0 0;
}

.btn {
  padding: 10px 30px;
  border-radius: 50px;
  font-weight: bold;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.3s ease;
  display: inline-block;
}

.btn.tutorial {
  color: #fff;
  background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
  text-decoration: none;
}

.btn:hover {
  transform: translateY(-3px);
  text-decoration: none;
}

.btn.tutorial:hover {
  background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  transform: translateY(-3px);
  text-decoration: none;
}

.home-img {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-lottie {
  width: clamp(260px, 34vw, 440px);
  height: clamp(260px, 34vw, 440px);
}

.logged-home :deep(.page-footer) {
  width: 100%;
  margin-top: auto;
  padding: 6px var(--app-gutter) 10px;
}

.logged-home :deep(.footer-inner) {
  padding-top: 0;
}

.text-animation {
  font-size: 34px;
  font-weight: 600;
  min-width: 280px;
}

.text-animation span {
  position: relative;
}

@keyframes cursor {
  to {
    border-left: 2px solid #7394f0;
  }
}

@keyframes words {
  0%,
  20% {
    content: 'técnico!';
  }
  21%,
  40% {
    content: 'eficiente!';
  }
  41%,
  60% {
    content: 'atencioso!';
  }
  61%,
  80% {
    content: 'rápido!';
  }
  81%,
  100% {
    content: 'completo!';
  }
}

@keyframes typing {
  10%,
  15%,
  30%,
  35%,
  50%,
  55%,
  70%,
  75%,
  90%,
  95% {
    width: 0;
  }
  5%,
  20%,
  25%,
  40%,
  45%,
  60%,
  65%,
  80%,
  85% {
    width: calc(100% + 8px);
  }
}

@media (max-width: 1199px) {
  .home-content {
    padding-top: calc(var(--app-header-h) + 4px);
  }

  h1,
  h3 {
    font-size: 2.6rem;
  }
}

@media (max-width: 767px) {
  .logged-home {
    min-height: calc(100dvh - 76px - env(safe-area-inset-bottom));
  }

  .home-content {
    flex-direction: column;
    width: 100%;
    text-align: center;
    padding-top: calc(var(--app-header-h) + 4px);
    padding-bottom: 2px;
    justify-content: center;
    flex: 1;
    gap: 12px;
  }

  .text-section {
    max-width: 680px;
    padding: 0 6px;
  }

  .home-img {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 2px;
    order: 3;
  }

  .hero-lottie {
    width: clamp(190px, 54vw, 260px);
    height: clamp(190px, 54vw, 260px);
  }

  .btn-group {
    margin-top: 14px;
  }

  .logged-home :deep(.page-footer) {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 4px;
  }
}

@media (max-width: 767px) and (min-height: 850px) {
  .home-content {
    padding-top: calc(var(--app-header-h) + 8px);
    gap: 14px;
  }

  .hero-lottie {
    width: clamp(220px, 56vw, 300px);
    height: clamp(220px, 56vw, 300px);
  }
}

@media (max-width: 480px) {
  h1,
  h3 {
    font-size: 2.5rem;
  }

  p {
    font-size: 1rem;
  }
}
</style>
